import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { VendorsStoreModule } from './store/module'
import { Tv3PlatformModule } from '@tokeet-frontend/tv3-platform'

@NgModule({
  imports: [CommonModule, Tv3PlatformModule, VendorsStoreModule],
  exports: [VendorsStoreModule, Tv3PlatformModule],
})
export class VendorsLibraryModule {}
